<section class="row-freight">
  <div class="row container-date">
    <div class="col-lg-4 col-md-6 title-purple" [title]="getStateDeviceText()">
      Estado: {{getStateDeviceText()}}
    </div>
    <div class="col-lg-4 col-md-6 title-purple word-break" [title]="satelliteLock?.imei || '-'">
      IMEI: {{satelliteLock?.imei || '-'}}
    </div>
  </div>
  <div class="row container-data">
    <div class="col-lg-4 col-md-6">
      <div class="label">Tipo</div>
      <div class="text-bold label-field word-break" [title]="satelliteLock?.type?.name || '-'">
        {{satelliteLock?.type?.name || '-'}}</div>
    </div>
    <div class="col-lg-4 col-md-6">
      <div class="label">ID</div>
      <div class="text-bold label-field word-break" [title]="satelliteLock?.id || '-'">{{satelliteLock?.id || '-'}}
      </div>
    </div>
    <div class="col-lg-4 col-md-6">
      <div class="label">
        Consecutivo
      </div>
      <div class="text-bold label-field word-break" [title]="satelliteLock?.consecutive || '-'">
        {{satelliteLock?.consecutive || '-'}}
      </div>
    </div>
  </div>

  <figure class="icon-arrow-container" (click)="openDetail()">
    <img src="/assets/svg/icons/icon-arrow-right-short.png" alt="">
  </figure>
</section>